import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting_/squawks/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
